@if (loadingTimeout()) {
  <app-timeout />
} @else if (loading()) {
  <div class="loading-container">
    <p-progressSpinner
      class="customProgressSpinner"
      [attr.aria-label]="'gate_administration.hardware_configuration.loading' | translate"
    />
  </div>
} @else {
  <div [formGroup]="form" class="configuration-form">
    <div
      *appHasPermission="{
        permissions: [permissions.allPermissions.HARDWARE_CONFIG_UPDATE],
      }"
      class="dialog-toolbar"
    >
      <app-svg-icon
        iconName="plus"
        iconColor="primary"
        class="pointer"
        [attr.aria-label]="'gate_administration.hardware_configuration.add_row' | translate"
        (click)="addConfigurationRow()"
      />
    </div>

    <div class="configuration-list">
      @if (rows().length === 0) {
        <span role="status">
          {{ "gate_administration.hardware_configuration.empty" | translate }}
        </span>
      }

      @for (row of rows(); track row.id; let rowIndex = $index) {
        <app-hardware-configuration-row
          [row]="row"
          [rowNumber]="rowIndex + 1"
          [adapterTypeOptions]="adapterTypeOptions"
          [operationOptions]="row.kind === 'supported' ? getOperationOptions(row) : operationOptions"
          [indexOptions]="row.kind === 'supported' ? getIndexOptions(row) : indexOptions"
          [canEdit]="canUpdateHardwareConfiguration"
          (removeRequested)="removeConfigurationRow(row.id)"
        />
      }
    </div>

    @if (form.controls.configurations.touched && form.controls.configurations.hasError("duplicateOperation")) {
      <p class="validation-message" role="alert">
        {{ "gate_administration.hardware_configuration.duplicate_operation" | translate }}
      </p>
    }
    @if (form.controls.configurations.touched && form.controls.configurations.hasError("duplicateTarget")) {
      <p class="validation-message" role="alert">
        {{ "gate_administration.hardware_configuration.duplicate_target" | translate }}
      </p>
    }
    @if (form.controls.configurations.touched && form.controls.configurations.hasError("duplicateCustomSignalLabel")) {
      <p class="validation-message" role="alert">
        {{
          "gate_administration.hardware_configuration.duplicate_custom_signal_label"
            | translate: { rows: getDuplicateCustomSignalLabelRows() }
        }}
      </p>
    }

    <div class="dialog-actions">
      <app-button buttonText="common.cancel" [disabled]="saving()" (click)="closeDialog()" />
      <app-button
        *appHasPermission="{
          permissions: [permissions.allPermissions.HARDWARE_CONFIG_UPDATE],
        }"
        buttonText="common.save"
        [disabled]="!hasGateSystemId || form.invalid || saving()"
        [loading]="saving()"
        (click)="saveConfiguration()"
      />
    </div>
  </div>
}
